import * as React from 'react';
import styled from 'styled-components';
import { useSetter, useGetter } from './slots';

declare module './slots' {
    interface SelectControls {
        'Multi': 'Multi',
    }
}


interface ControlInput {
    className?: string,
}


const Component = React.forwardRef<HTMLInputElement, ControlInput>(({ className }) => {
    
    const multi = useGetter('multi');

    useSetter('target', {
        tag: 'Multi',
    });

    return (
        <React.Fragment>
            {multi.get().map((item) => {
                return (
                    <Item 
                        key={item.id}
                        id={item.id}
                        className={className}
                        value={item}>
                        {item.text}
                    </Item>
                );
            })}
        </React.Fragment>
    );
});

export default Component;

type ItemProps = {
    id: number,
    children: React.ReactNode,
    value: Record<string, any>,
    className?: string,
}

const Item = ({ id, children, className, value }: ItemProps) => {
    const multi = useGetter('multi');
    const service = useGetter('service');
    const dropdownTarget = useGetter('dropdownTarget');

    const onRemove = () => {
        multi.removeAt(id);
        dropdownTarget.modifyData(xs => [value, ...xs]);
        service.onSelect(multi.get(), service.name);
    }
    

    return (
        <ItemS className={className}>
            <Text>
                {children}
            </Text>
            <Close
                onMouseDown={onRemove}>
                ×
            </Close>
        </ItemS>
    );
}

const ItemS = styled.div`
    background: #FFFFFF;
    border: 1px solid #E1E1F1;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
    padding: 5px 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: grid;
    margin: 5px;
    align-items: baseline;
    grid-template-columns: 1fr max-content;
    grid-gap: 0 5px;
`;

const Text = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`;

const Close = styled.button`
    border-radius: 50%;
    border: 1px solid #DDDDE1;
    color: #918EB0;
    width: 14px;
    height: 14px;
    line-height: 4px;
`;
